function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.4 4.8c-2.64 0-4.8 2.16-4.8 4.8 0 1.59.78 3 1.98 3.88C1.47 14.52 0 16.69 0 19.2h1.6c0-2.66 2.14-4.8 4.8-4.8s4.8 2.14 4.8 4.8h1.6c0-2.66 2.14-4.8 4.8-4.8s4.8 2.14 4.8 4.8H24c0-2.51-1.47-4.68-3.58-5.73 1.19-.88 1.98-2.29 1.98-3.88 0-2.64-2.16-4.8-4.8-4.8s-4.8 2.16-4.8 4.8c0 1.59.78 3 1.97 3.88A6.432 6.432 0 0012 16.09a6.43 6.43 0 00-2.77-2.62 4.824 4.824 0 001.97-3.88c0-2.63-2.16-4.79-4.8-4.79zm0 1.6c1.78 0 3.2 1.42 3.2 3.2s-1.42 3.2-3.2 3.2-3.2-1.42-3.2-3.2 1.42-3.2 3.2-3.2zm11.2 0c1.78 0 3.2 1.42 3.2 3.2s-1.42 3.2-3.2 3.2c-1.78 0-3.2-1.42-3.2-3.2s1.42-3.2 3.2-3.2z"
});

function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "ad374aaaeaa1f864831a930a55ee518f.svg";
export { SvgPeople as ReactComponent };